// extracted by mini-css-extract-plugin
export default {"login":"login_xvEeg","loginLeft":"loginLeft_DzFXz","resettingPassword":"resettingPassword_a92mv"};